<template>
  <div>
    <!-- BOC:[header] -->
   <v-row class="mb-3">
      <v-col class="text-right">
        <v-btn
          color="primary"
          large
          :disabled="parent.visibility=='public'"
          :to="{name:'PageModeratorEventEventInvitedPlayerAdd',params:{parentId:parent.id,parent:parent}}"
        >
          + New Player
        </v-btn>
      </v-col>
    </v-row>
    <!-- EOC -->
    <!-- BOC:[table] -->
    <BreadBrowseTable
    v-if="parent.visibility != 'public'"
      role="Moderator"
      :model="model"
      :url="url"
      :isSearchable="true"
      :parent="parent"
      :modelParent="modelParent"
      ref="bread_table"
    ></BreadBrowseTable>
    <!-- EOC -->
     <div class="pa-3 text-center" v-else>
  This event is not a private event.
     </div>
  </div>
</template>
  
  <script>
//BOC:[model]
import modelParent from "@/models/items/event";
import model from "@/models/items/eventInvitedPlayer";
//EOC
//BOC:[table]
import BreadBrowseTable from "@/components/Bread/BreadBrowseTableV2";
//EOC
import { mapState } from "vuex";
export default {
  components: {
    //BOC:[table]
    BreadBrowseTable,
    //EOC
  },
  computed: mapState({
    school: (state) => state.school.data,
  }),
  props: ["role", "parent"],
  data: () => ({
    //BOC:[model]
    modelParent: modelParent,
    model: model,
    //EOC
    url: null,
    groupId: null,
    //EOC
  }),
  watch: {
   
  },
  created() {
    this.url = `${this.$api.servers.event}/api/v1/en/moderator/event/${this.parent.id}/invitedPlayer`;
   
  },
  mounted() {
  },
  methods: {
   
  },
};
</script>